// extracted by mini-css-extract-plugin
export var quoteContainer = "TestimonialSection-module--quote-container--3dVfd";
export var logo = "TestimonialSection-module--logo--1pD7A";
export var bottom = "TestimonialSection-module--bottom--3UDTc";
export var slantedBorder = "TestimonialSection-module--slanted-border--NIu_F";
export var empty = "TestimonialSection-module--empty--4nLDc";
export var attribution = "TestimonialSection-module--attribution--2qGJR";
export var name = "TestimonialSection-module--name--33uMg";
export var cardGrid = "TestimonialSection-module--card-grid--1DlUa";
export var darkBlue = "TestimonialSection-module--dark-blue--3atM0";
export var cardGridMobile = "TestimonialSection-module--card-grid-mobile--3e5dP";